import { TOGGLE_SIDE_NAV } from "../actions/types";

const initialState = {
  open: false,
};

// Side Navbar reducer
export const sideNavbarReducer = (state = initialState, { type }) => {
  switch (type) {
    case TOGGLE_SIDE_NAV:
      return {
        open: !state.open,
      };
    default:
      return state;
  }
};
